var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contacts-dashboard"},[_c('mu-title',{attrs:{"color":"secondary","textStrong":"700"}},[_vm._v("Contatos")]),_c('mu-options',{attrs:{"options":_vm.options}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }